import { useEffect, useState } from 'react';
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { getFirst7PlaylistVideosByTitle } from '../../api/youtubeApi';
import Loader from '../common/loader/loader';
import './Playlist.css';

const Playlist = () => {
  const [videos, setVideos] = useState([]);
  const [playingIndex, setPlayingIndex] = useState(null);
  const [hovered, setHovered] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slideDirection, setSlideDirection] = useState("");


  useEffect(() => {
    const fetchData = async () => {
      const playlistUrl = "https://www.youtube.com/watch?v=kuNm-nWiEjo&list=PLXSmwH8Jlg2ZL_9XpVsMZGhFF2Wrgu50S";
      const data = await getFirst7PlaylistVideosByTitle(playlistUrl);
      setVideos(data);
    };
    fetchData();
  }, []);

  if (videos.length === 0) return <Loader />;

  const galleryItems = videos.map((v) => ({
    original: v.thumbnail,
    thumbnail: v.thumbnail,
    description: v.title,
    videoLink: v.videoLink,
  }));

  return (
    <div style={{ position: "relative" }}>
      {/* ImageGallery: only images */}
      {/* <ImageGallery
        items={galleryItems}
        showPlayButton={false}
        showFullscreenButton={false}
        showThumbnails={playingIndex === null}
        thumbnailPosition="bottom"
        // autoPlay={true}
        // slideInterval={3000}
        // infinite={true}
        renderItem={(item) => (
          <div style={{ textAlign: "center" ,position:'relative'}}>
            <img
              src={item.original} alt={item.description} className='bgOfTamseel'></img>
            <img
              src={item.original}
              alt={item.description}
              style={{ objectFit: 'cover', cursor: 'pointer' }}
              onClick={() => setPlayingIndex(galleryItems.indexOf(item))}
            />
            <p style={{ marginTop: "10px" }}>{item.description}</p>
          </div>
        )}
      /> */}
      <div className="playlist-gallery-wrapper">
        <ImageGallery
          items={galleryItems}
          showPlayButton={false}
          showFullscreenButton={false}
          showThumbnails={playingIndex === null}
          thumbnailPosition="bottom"
          // autoPlay={true}
          // slideInterval={3000}
          // infinite={true}
          onSlide={(index) => {
            setSlideDirection(index > currentIndex ? "right" : "left");
            setCurrentIndex(index);
            // Reset direction after animation
            // setTimeout(() => setSlideDirection(""), 600);
          }}
          renderItem={(item) => (
            <div style={{ textAlign: "center", position: 'relative' }}>
              <img src={item.original} alt={item.description} className='bgOfTamseel' data-aos="zoom-in" />
              <img
                data-aos="zoom-in"
                src={item.original}
                alt={item.description}
                style={{ objectFit: 'cover', cursor: 'pointer' }}
                onClick={() => setPlayingIndex(galleryItems.indexOf(item))}
              />
              {/* <p style={{ marginTop: "10px" }}>{item.description}</p> */}
            </div>
          )}
        />


        {/* ✅ Left thumbnail preview */}
        <div
          key={`left-${currentIndex}`} // triggers re-render when slide changes
          className="side-thumb left-thumb fade-thumb"
          onClick={() =>
            setCurrentIndex((currentIndex - 1 + galleryItems.length) % galleryItems.length)
          }
        >
          <img
            data-aos="zoom-in"
            src={
              galleryItems[(currentIndex - 1 + galleryItems.length) % galleryItems.length]
                ?.thumbnail
            }
            alt="Prev thumbnail"
          />
        </div>

        {/* ✅ Right thumbnail preview */}
        <div
          key={`right-${currentIndex}`} // triggers re-render when slide changes
          className="side-thumb right-thumb fade-thumb"
          onClick={() =>
            setCurrentIndex((currentIndex + 1) % galleryItems.length)
          }
        >
          <img
            data-aos="zoom-in"
            src={
              galleryItems[(currentIndex + 1) % galleryItems.length]?.thumbnail
            }
            alt="Next thumbnail"
          />
        </div>
      </div>

      {/* Video overlay */}
      {playingIndex !== null && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "#000",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <iframe
            width="80%"
            height="80%"
            src={`https://www.youtube.com/embed/${videos[playingIndex].videoLink.split("v=")[1]}?autoplay=1`}
            title={videos[playingIndex].description}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>

          {/* Back button right center */}
          {hovered && (
            <button
              onClick={() => setPlayingIndex(null)}
              style={{
                position: "absolute",
                top: "50%",
                right: "20px",       // right center
                transform: "translateY(-50%)",
                zIndex: 10000,
                padding: "10px 20px",
                fontSize: "18px",
                cursor: "pointer",
                background: "rgba(0,0,0,0.6)",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
              }}
            >
              Back
            </button>
          )}
        </div>
      )}

      {/* Center thumbnails */}
      <style>
        {`
          .image-gallery-thumbnails-wrapper {
            justify-content: center !important;
          }
        `}
      </style>
    </div>
  );
};

export default Playlist;
